import { Component, Input } from '@angular/core';

import { IMessageCtx } from 'src/app/shared/components/message/message.component';
import { IPost } from 'src/app/shared/models/post';

@Component({
  selector: 'app-organization-updates',
  templateUrl: './organization-updates.component.html',
  styleUrls: ['./organization-updates.component.scss']
})
export class OrganizationUpdatesComponent {
  @Input() isMyOrg: boolean;
  @Input() orgId: number;
  @Input() messageCtx: IMessageCtx;
  @Input() posts: IPost[];
}
